import { render, staticRenderFns } from "./printview.vue?vue&type=template&id=68e31196&scoped=true&"
import script from "./printview.vue?vue&type=script&lang=js&"
export * from "./printview.vue?vue&type=script&lang=js&"
import style0 from "./printview.vue?vue&type=style&index=0&id=68e31196&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68e31196",
  null
  
)

export default component.exports